<template>
    <div>
        <!-- 卡片视图区域 -->
        <el-card>
        <!-- 搜索与添加区域 -->
         <collapse @getDataList="search">
        <collapse-item>
          <span>设备标识码</span>
          <el-input placeholder="请输入设备标识码" v-model.trim="queryInfoparams.params.uniqueCode" clearable></el-input>
        </collapse-item>
        <collapse-item>
          <span>代理商</span>
          <el-input placeholder="请输入代理商" v-model.trim="queryInfoparams.params.agencyName" clearable></el-input>
        </collapse-item>

        <collapse-item>
          <el-date-picker v-model="queryInfoparams.params.startTime" type="daterange" range-separator="-" start-placeholder="start Date" format="yyyy-MM-dd" end-placeholder="end Date" :picker-options="pickerOptions">></el-date-picker>
        </collapse-item>
      </collapse>
        <el-row type="flex" justify="end">
            <el-col class="searchBtns" :span="6">
            <el-button-group>
                <el-button plain size="smll" icon="el-icon-share">设备校准</el-button>
                <el-button plain size="small" icon="el-icon-share">导出excel</el-button>
            </el-button-group>
            </el-col>
        </el-row>

         <!-- 协议列表区域 -->
        <el-table :data="equipmentList"  border stripe>
          <el-table-column type="index" label="No."></el-table-column>
          <el-table-column label="设备ID" sortable prop="uniqueCode"></el-table-column>
          <el-table-column label="代理商" sortable prop="agencyName"></el-table-column>
          <el-table-column label="公司" sortable prop="companyName"></el-table-column>
          <el-table-column label="水工名" sortable prop="lastName"></el-table-column>
          <el-table-column label="开始时间" sortable prop="startTime"></el-table-column>
          <el-table-column label="停止时间" sortable prop="stopTime"></el-table-column>
          <el-table-column label="说明" sortable prop="stopDesc"></el-table-column>
          <el-table-column label="持续使用时间" sortable prop="duration"></el-table-column>
          <el-table-column label="最新校准时间" sortable prop="calibrationTime"></el-table-column>
          <el-table-column label="推荐校准时间" sortable prop="proposalTime"></el-table-column>
           <el-table-column label="设备状态" sortable prop="status">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status==='1'" type="success">启用</el-tag>
              <el-tag v-else-if="scope.row.status==='2'" type="info">禁用</el-tag>
              <el-tag v-else="scope.row.status==='3'" type="info">已终止</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180px">
            <template slot-scope="scope">
              <!-- 修改按钮 -->
              <el-tooltip effect="dark" content="设备校准" placement="top" :enterable="false">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  @click="showEditDialog(scope.row.id)"
                ></el-button>
              </el-tooltip>
                <el-tooltip >
                  <el-button
                    type="text"
                    size="small"
                    v-if="scope.row.status === '1'"
                    @click="agreementEnable(scope.row.id)"
                    >启用</el-button>
                  <el-button
                    type="text"
                    size="small"
                    v-if="scope.row.status === '2'"
                    @click="agreementDisable(scope.row.id)"
                  >禁用</el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      <!-- 分页区域 -->
      <el-pagination

        @size-change="handleSizeChange"

        @current-change="handleCurrentChange"

        :current-page="queryInfoparams.current"

        :page-sizes="[5, 10, 15, 20]"

        :page-size="queryInfoparams.size"

        layout="total, sizes, prev, pager, next, jumper"

        :total="total"

      ></el-pagination>
     </el-card>
    </div>
</template>

<script>
  import Collapse from '@/components/collapse/Collapse'
  import CollapseItem from '@/components/collapse/CollapseItem'

  export default {
    components:{
      Collapse,
      CollapseItem
    },
    data(){
      return{
        
        queryInfoparams: {
        // 当前页码
        current: 0,// @ts-nocheck

        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',

        restaurants: [],
        state: '',
 
      },
        // 设备列表
      equipmentList: [],

      total: 0,
    }
  },
  methods: {

    handleSelect(){},
    querySearch(){},
           //导出excel
    exportExcel(){
      console.log('-----------')
      let res = this.$export('equipment/exportExcel', JSON.stringify(this.queryInfoparams), 'equipment')
    },
    search(){
        this.queryInfoparams.current=0
         this.getEquipmentList()
    },
    // 获取 查询用户数据列表
    async getEquipmentList(data) {
      // console.log(this.equipmentList)
      // 分页查询用户
      this.$post('equipment/pageQuery', this.queryInfoparams).then(
        ({ data: res }) => {
          this.equipmentList = res.records
           this.restaurants = res.records
          //  console.log("王昌侣",this.restaurants)
          this.total = res.total
          // console.log(this.equipmentList)
        }
      )
    },
  },
  created() {
  this.search()
  },
}
</script>
<style lang="less" scoped>
.el-select {
  width: 100%;
}
/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}
.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}
.el-row {
  flex: 1;
}
.el-tag {
  border: none !important;
}
.collapse {
  display: flex;
  justify-content: space-between;
}
</style>